import "../../assets/css/common/ErrorModal.css";

function ErrorModal({ show, message, onClose }) {
  if (!show) return null;

  return (
    <div className="error-modal-overlay" data-testid="error-modal">
      <div className="error-modal">
        <div className="error-modal-body">
          <strong>⚠ Warning!</strong>
          <p>{message}</p>
        </div>
        <button onClick={onClose}>OK</button>
      </div>
    </div>
  );
}

export default ErrorModal;